import reducer from './reducers';

export { default as configSelectors } from './selectors';
export { default as configOperations } from './operations';
export { default as configTypes } from './types';
export { default as normalizeData } from './schema';

export default reducer;
